import { STATES, STN_BASE_URL, API_BASE_URL } from "../constants";
import { store } from '../store/index.js';

export function addLeadingZero(num, size) {
  num = num.toString();
  while (num.length < size) num = "0" + num;
  return num;
}

export function adjustForTimezone(date) {
  var timeOffsetInMS = date.getTimezoneOffset() * 60000;
  date.setTime(date.getTime() + timeOffsetInMS);
  return date;
}

export function validateEmail(email) {
  // TODO: comment which rules are accepted

  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
}

export function validatePhoneNumber(number) {
  // TODO: comment which rules are accepted

  return number.match(
    /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im
  );
}

export function validateZipCode(ZIP) {
  // TODO: comment which rules are accepted

  return ZIP.match(/^((\d{3,5}-\d{1,4})|(\d{3,5})|([A-Z]\d[A-Z]\s\d[A-Z]\d))$/);
}

export function validateSpecialCharacters(input) {
  // TODO: comment which rules are accepted

  return input.match(/([?@|!%()¡¿*~}{¬]+)/);
}

export function validatePositiveInteger(input) {
  // TODO: comment which rules are accepted

  let expression =
    /^(\d|\d{1,9}|1\d{1,9}|20\d{8}|213\d{7}|2146\d{6}|21473\d{5}|214747\d{4}|2147482\d{3}|21474835\d{2}|214748364[0-7])$/;

  var match = String(input).match(expression);

  if (match) {
    return true;
  } else {
    return false;
  }
}

export function validatePositiveFloat(input) {
  // TODO: comment which rules are accepted

  let expression = /^(?:[0-9]\d*|0*|)?(?:\.\d+)?$/g;

  var match = String(input).match(expression);

  if (match) {
    return true;
  } else {
    return false;
  }
}


export function isoStringToHuman(isoString) {
  var today = new Date(isoString);
  var yyyy = today.getFullYear();
  var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
  var dd = String(today.getDate()).padStart(2, "0");

  var hh = String(today.getHours() % 12).padStart(2, "0");
  var min = String(today.getMinutes()).padStart(2, "0");
  var AmPm = today.getHours() >= 12 ? "PM" : "AM";

  // today = mm + '/' + dd + '/' + yyyy;
  // parse to integer on 10th base to avoid showing 0's
  return `${parseInt(mm, 10)}-${parseInt(dd, 10)}-${yyyy} ${parseInt(
    hh,
    10
  )}:${min} ${AmPm}`;
}

export function convertTo24HrsFormat(time) {
  const slicedTime = time.split(/(PM|AM)/gm)[0];

  let [hours, minutes] = slicedTime.split(":");

  if (hours === "12") {
    hours = "00";
  }

  let updateHourAndMin;

  function addition(hoursOrMin) {
    updateHourAndMin =
      hoursOrMin.length < 2 ? (hoursOrMin = `${0}${hoursOrMin}`) : hoursOrMin;

    return updateHourAndMin;
  }

  if (time.endsWith("PM")) {
    hours = parseInt(hours, 10) + 12;
  }

  return `${addition(hours)}:${addition(minutes)}`;
}

export function humanStringToDateObj(HumanDateString) {
  /* the HumanDateString to converse in this funcion have the following format:
   *  "M-DD-YYYY H:MM PM"
   */
  let prevDate = HumanDateString?.split(" ")[0];
  let prevTime = convertTo24HrsFormat(HumanDateString?.split(" ")[1],HumanDateString?.split(" ")[2]);

  let year = prevDate?.split("-")[2];
  let month = prevDate?.split("-")[1];
  let day = prevDate?.split("-")[0];

  let hours = prevTime?.split(":")[0];
  let minutes = prevTime?.split(":")[1];

  let DateObj = new Date(Date.UTC(+year, month - 1, +day, hours, minutes)); // january is 0 in date objet, so month -1

  return DateObj;
}

export const arrayToDict = (arrayObj, key) => {
  let r = {};
  arrayObj.map((oneElement) => (r[oneElement[key]] = oneElement));
  return r;
}

function eventsToDict(events) {
  let r = {};
  events.forEach((event) => {
    if (event.success) {
      let eventId = event.bteId;
      r[eventId] = event;
    }
  });
  return r;
}

function escalationsToDict(escalations = []) {
  let r = {};
  escalations.forEach((escalation) => {
    r[escalation.jobId] = escalation;
  });
  return r;
}


function getEvents(events = []) {
  //U: get an array of API events response and returns an array of events info
  let r = {};

  events.forEach((event) => {
    if (event.success) {
      let eventId = event.eventModel.bteId;
      r[eventId] = event.eventModel;
    } else {
      console.log("EVENT ERROR" + JSON.stringify(event));
    }
  });
  return r;
}

export const getJobEscalation = (job, escalations = []) => {
  let escalationsForJob = escalations.filter((escal) => escal.jobId === job.id);

  let activeEscalation = escalationsForJob.find(
    (escalation) => escalation.issueResolved == null
  );
  let escalationHistory = escalationsForJob.filter(
    (escalation) =>
      escalation.issueResolved !== null &&
      escalation.issueResolved !== undefined
  );

  return {
    active: activeEscalation,
    history: escalationHistory,
  };
}

export const parseJobApiResponse = (res = {}) => {
  //use this function to parse the information from the API
  let jobs = res.jobs || [];
  let r = [];

  let events = getEvents(res.events);

  jobs.forEach((job) => {
    let jobEscalation = getJobEscalation(job, res.escalations);
    r.push({
      job: job,
      escalationActive: jobEscalation.active,
      escalationHistory: jobEscalation.history,
      event: events[job.eventId],
    });
  });

  return r;
}

export const jobsCleanUp = (res = {}) => {
  let jobsObj = res.jobs;
  let eventsObj = res.events;
  // let jobEscalations = res.jobEscalations;

  let jobsFullData = getFullJobInfo(jobsObj, eventsObj);

  return jobsFullData;
}

export const getFullJobInfo = (jobs = [], events = [], escalations) => {
  let eventsDict = eventsToDict(events); //A: dictionar to fast index;
  let escalationsDict = escalationsToDict(escalations);

  let jobsFullInfo = jobs.map((oneJob) => {
    let eventInfo = eventsDict[oneJob.eventId];
    let escalationInfo = escalationsDict[oneJob.id];
    if (eventInfo) return { ...oneJob, ...eventInfo, ...escalationInfo };
  });

  jobsFullInfo = jobsFullInfo.filter((job) => job != null);
  return jobsFullInfo;
}

export const getEscalatonInfo = (jobs, events, escalations) => {
  let r = {};
  escalations.forEach((escalation) => {
    if (escalation.issueResolved == null) {
      //A: dont datetime still escalated
      r[escalation.jobId] = escalation;
    }
  });
  return r;
}

export const getStateByName = (stateName) => {
  let stateData = STATES.filter((state) => state.name == stateName);
  if (stateData.length > 0) return stateData[0];
}

export const creditCardMask = (cc) => {
  if (!cc) return "";
  return `${cc.cardType.name} XXXX-${cc.last4Digits} ${cc.expirMonth}/${cc.expirYear}`;
}

export const isBlank = (str) => {
  return (!str || /^\s*$/.test(str));
}

// ------------- STN API helper functions -------------------------
export function openStnInvoice(invoiceId){
  return window.open(`${STN_BASE_URL}#/invoice/search?Invoice=${invoiceId}`,"_blank")
}

export const copyStnInvoice = (invoiceId) => {
  navigator.clipboard.writeText(`${STN_BASE_URL}#/invoice/search?Invoice=${invoiceId}`);
}

export const linkIsFileInS3 = (link) => {
  return link?.includes(".encorehive.com");
}

export const getFileNameFromEHLink = (link) => {
  return link?.split("/").pop();
}

//A: in the past we save the whole URL like this: prod-green/download/fileName or prod-blue/download/fileName
//A: that is incorrect, we should use the main url like: app.encorehive.com/download/fileName 
function getFixedUrlForDowloadFileFromEH(url) {
  let fileName= url.split("/").pop();
  return API_BASE_URL + "file/download/" + fileName;
}

export const downloadFile = (url) => {
  console.log("[downloadFile], url:", url);
  let fixedUrl = getFixedUrlForDowloadFileFromEH(url);

  // Get token from redux store
  const { auth: { accessToken } } = store.getState();

  // Create form with target="_blank" to open in a new window
  let form = document.createElement('form');
  form.method = 'POST';
  form.target = '_blank';
  form.action = fixedUrl;

  // Add token as hidden input
  let input = document.createElement('input');
  input.type = 'hidden';
  input.name = 'jwtToken';
  input.value = accessToken;
  form.appendChild(input);

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

export function getTicketsCanBuy(event, buys) {
  let ticketsCanBuy;
  //console.log("DEBUG: event: ", event)
  if (event?.useRunLevelLimit) {
    ticketsCanBuy = (event?.runLimitNumberOfTickets - buys.sum_QtyPurchasedPerRun);
  } else {
    ticketsCanBuy =
      (event?.eventLimitNumberOfTickets - buys.sum_QtyPurchasedPerEvent);
  }
  return ticketsCanBuy >= 0 ? ticketsCanBuy : 0; // don't return negative values
}

export function getRemainingTickets(event, buys) {
  console.log("DEBUG: pure.js getRemainingTickets event: ", event, "buys: ", buys)
  if (event == null || !Array.isArray(buys)) return 0;
  if(!buys || buys.length === 0) return event?.eventLimitNumberOfTickets;

  let buysForSelectedEvent = null;
   if (event.runId) {
    buysForSelectedEvent = buys.find(b => b.runId === event.runId);
  } else {
    buysForSelectedEvent = buys.find(b => b.eventId === event.bteId);
  }

  console.log("DEBUG: pure.js getRemainingTickets, buysForSelectedEvent: ", buysForSelectedEvent)
  let remainingTickets = 0;

  if (buysForSelectedEvent) {
    remainingTickets = getTicketsCanBuy(event, buysForSelectedEvent)
  } else {
    remainingTickets = event?.eventLimitNumberOfTickets
    // if no buys, then the remaining tickets for the user are the eventLimitNumberOfTickets
  }
  //console.log("DEBUG: REMAINING TICKETS: ", remainingTickets)
  return remainingTickets
}

export const mergeSwarmsAndEvents = (events, swarms) => {
  let merged = [];
  let swarmInformationByEventId = {};
  swarms.forEach((swarm) => { swarmInformationByEventId[swarm.bteId] = swarm; });
  events.forEach((event) => {
    const swarmInfo = swarmInformationByEventId[event.bteId];
    merged.push({
      bteId: event.bteId,
      name: event.name,
      date: event.date,
      primaryEventUrl: event.primaryEventUrl,
      salesDates: event.salesDates,
      eventLimitNumberOfTickets: event.useRunLevelLimit ? event.runLimitNumberOfTickets : event.eventLimitNumberOfTickets,
      code: swarmInfo?.code || "",
      instructions: swarmInfo?.instructions || "",
      reward: swarmInfo?.reward || 3,
      rewardTypeId: swarmInfo?.rewardTypeId || 1,
      isNow: swarmInfo?.isNow || false,
      running: swarmInfo?.running || false,
      salesDate: getSaleDate(event, swarmInformationByEventId), //A: default value "now"
      swarmId: swarmInfo?.id,
      venue: event?.venue,
    });
  });
  return merged;
}

export const formatMoney = (value) => {
  // Configurar el formateador.
  const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
  });

  // Verificar si el valor es undefined o null y asignar 0 en ese caso.
  const validValue = value == null ? 0 : value;

  // Formatear y devolver el valor.
  return formatter.format(validValue);
}

export const getSaleDate = (event, swarmInformationByEventId) => {
  let saleDateExists = swarmInformationByEventId[event.bteId]?.salesDate;
  let swarmIsToday = swarmInformationByEventId[event.bteId]?.isNow;
  return (!saleDateExists || swarmIsToday) ? "now" : swarmInformationByEventId[event.bteId]?.salesDate;
}

//This function is for transaction screen, when obj is a valid period, this function returns the status of the period
export function getPeriodStatus(obj) {
  if (obj?.isCompleted) {
    return "COMPLETED";
  }

  let startDate, endDate;

  // If periodDate is available, use it; otherwise, use startDate and endDate
  if (obj?.periodDate) {
    [startDate, endDate] = obj?.periodDate.split('-').map(date => new Date(date.trim()));
  } else if (obj?.startDate && obj?.endDate) {
    startDate = new Date(obj?.startDate);
    endDate = new Date(obj?.endDate);
  } else {
    // If none of the date fields are available, return a default status
    return "UNDEFINED";
  }

  const currentDate = new Date();

  // Verify if the current date is between the start and end date
  if (currentDate >= startDate && currentDate <= endDate) {
    return "CURRENT";
  } else {
    return "PENDING";
  }
}


export const updateQueryParam = (history, location, key, value) => {
  const searchParams = new URLSearchParams(location.search);
  
  if (value === undefined || value === null || value === "") {
    searchParams.delete(key);
  } else {
    searchParams.set(key, value);
  }
  
  history.push({
    pathname: location.pathname,
    search: searchParams.toString()
  });
}
